import React from 'react';
import universal from 'react-universal-component';
import { useSelector } from 'react-redux';
import { Transition, TransitionGroup } from 'react-transition-group';
import SubscribeForm from '../../components/SubscribeForm';
import SubscribeThanks from '../../components/SubscribeThanks';

import {
  Headline,
  BarTextSection,
  IntroCategorySection,
  Intro,
  CategorySection,
  Category,
  LandingPageContent,
  LandingPageContainer,
  CyanDivider,
  BarSection,
} from './LandingPage.styles';

const AsyncBackgroundAnim = universal(import(`../../components/BackgroundAnim`));
const AsyncProgressBar = universal(import(`../../components/ProgressBar`));

const LandingPage = () => {
  const status = useSelector(
    (state) => state.subscription.createSubscriberStatus
  );

  const success = status.loaded && !status.failed;

  return (
    <LandingPageContainer>
      <AsyncBackgroundAnim />
      {success ? <SubscribeThanks /> : 
      <>
        <BarSection>
          <AsyncProgressBar
            currentStep={1}
          />
        </BarSection>
        <TransitionGroup appear exit={false} component={null}>
          <Transition timeout={100} key="input">
            {(state) => {
              return (
                <LandingPageContent state={state}>
                  <Headline>Gaming News</Headline>
                  <BarTextSection>
                    <IntroCategorySection>
                      <Intro>We curate and analyze news from likable & trusted sources in the video game industry and deliver it right to your inbox.</Intro>
                      <CategorySection>
                        <Category>Discover new games</Category>
                        <CyanDivider />
                        <Category>Catch up on the latest news</Category>
                        <CyanDivider />
                        <Category>Discuss exclusive insights with your friends</Category>
                      </CategorySection>
                    </IntroCategorySection>
                  </BarTextSection>
                  <SubscribeForm page='landing-page' />
                </LandingPageContent>
              );
            }}
          </Transition>
        </TransitionGroup>
      </>
      }
    </LandingPageContainer>
  );
};

export default LandingPage;
